import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
let IconSvg = class IconSvg extends Vue {
    get iconPath() {
        return `/static/images/sprite.svg#${this['icon'] || ''}`;
    }
    get inlineStyles() {
        let stylesString = '';
        const width = this['width'];
        const height = this['height'];
        if (width) {
            stylesString += `width:${+width}px;`;
        }
        if (height) {
            stylesString += `height:${+height}px;`;
        }
        return stylesString;
    }
};
__decorate([
    Prop()
], IconSvg.prototype, "icon", void 0);
__decorate([
    Prop()
], IconSvg.prototype, "width", void 0);
__decorate([
    Prop()
], IconSvg.prototype, "height", void 0);
IconSvg = __decorate([
    Component
], IconSvg);
export default IconSvg;
